let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ePOyH"), load("3XMOA"), load("ffEVr"), load("dezv5")]).then(() => parcelRequire('hD4yV'));